import type { Modal as MantineModal, ModalProps } from '@mantine/core';
import { Container, Modal } from '@mantine/core';
import React from 'react';

import styles from './Modal.module.css';

export const LBModalFullscreenLayout = React.forwardRef<
  React.ElementRef<typeof MantineModal>,
  ModalProps
>(({ children, ...props }, ref) => (
  <Modal
    {...props}
    ref={ref}
    centered
    fullScreen
    lockScroll
    classNames={styles}
    withCloseButton={false}
  >
    <Container size='xs' style={{ maxWidth: '375px' }}>
      {children}
    </Container>
  </Modal>
));
